import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {count, first, take} from "rxjs/operators";
import {HttpClient} from '@angular/common/http';
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Partner} from "../interface/partner";
import {Form} from "../interface/form";
import {DynamicDictionary} from "../interface/dynamic-dictionary";
import {FormRow} from "../interface/form-row";
import {CommissionAnnex} from "../interface/commission-annex";
import {Uuid} from "../interface/response/uuid";
import {FilterService} from "./filter.service";
import {Registration} from "../interface/registration";

@Injectable({
  providedIn: 'root'
})
export class FormAddService {
  public readonly formRowListSubject: ReplaySubject<CountedAndPaginated<FormRow>>
    = new ReplaySubject<CountedAndPaginated<FormRow>>(1);
  private readonly formListSubject: ReplaySubject<CountedAndPaginated<Form>> = new ReplaySubject<CountedAndPaginated<Form>>(1);


  constructor(
    private filterService: FilterService,
    private http: HttpClient,
  ) {
  }

  public sendForm(formData: object, formId: string): Observable<any> {
    if (!formId) {
      return this.http.post(`/rest/crm/formDictionary`, formData)
        .pipe(
          take(1)
        );
    } else {
      return this.http.put(`/rest/crm/formDictionary/${formId}`, formData)
        .pipe(take(1));
    }
  }
   public assignPartner(formData: any, uuid: string): Observable<any> {
    return this.http.post(`/rest/crm/form-row/${uuid}/partner`, formData)
      .pipe(first());
  }
  public statusUpdate(formData: any, uuid: string): Observable<any> {
    return this.http.post(`/rest/crm/form-row/${uuid}/status`, formData)
      .pipe(first());
  }

  public loadList(page: number, pageSize: number, filters: object,  sort?: {sortBy?: string; sortOrder?: string}): void {
    this.http.get(`/rest/crm/formDictionary?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<Form>) => {
        this.formListSubject.next(result);
      });
  }
  public loadListFormRow2(page: number, pageSize: number, filters: object, sort?: {sortBy?: string; sortOrder?: string}): void
  {
    let loadFilter: string;
    if (sort !== null){
      loadFilter = `sortBy=${sort.sortBy}&sortOrder=${sort.sortOrder}&` + this.filterService.parseFilters(filters);
    } else {
      loadFilter = this.filterService.parseFilters(filters);
    }
    this.http.get(`/rest/crm/formRow?page=${page + 1}&pageSize=${pageSize}&` + loadFilter)
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<FormRow>) => {
        this.formRowListSubject.next(result);
      });
  }
  public getFormListSubject(): ReplaySubject<CountedAndPaginated<Form>> {
    return this.formListSubject;
  }

  public get(id: any): Observable<Form> {
    return this.http.get(`/rest/crm/formDictionary/${id}`)
      .pipe(first()) as Observable<Form>;
  }

  public getFormRowListSubject(): ReplaySubject<CountedAndPaginated<FormRow>> {
    return this.formRowListSubject;
  }
  downloadRowReport(filters: any): Observable<Uuid> {
    return this.http.post(`/rest/crm/form/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  deleteFormRow(formRowId: string): Observable<any> {
    return this.http.delete(`/rest/crm/form-row/${formRowId}`)
      .pipe(first());
  }
  deleteFormDictionary(formDictionaryId: string): Observable<any> {
    return this.http.delete(`/rest/crm/formDictionary/${formDictionaryId}`)
      .pipe(first());
  }
}
